import React, { createContext, Dispatch, SetStateAction, useState, useMemo, ReactNode } from 'react';
import { Trigger } from '../types';

type DataLoaderContextType = {
  trigger: Trigger;
  setTrigger: Dispatch<SetStateAction<Trigger>>;
};

export const DataLoaderContext = createContext<DataLoaderContextType>({
  trigger: 'Auto',
  setTrigger: () => {},
});

type DataLoaderContextProviderProps = {
  children: ReactNode;
};

export function DataLoaderContextProvider({ children }: DataLoaderContextProviderProps) {
  const [trigger, setTrigger] = useState<Trigger>('Auto');

  const value = useMemo(
    () => ({
      trigger,
      setTrigger,
    }),
    [trigger]
  );

  return <DataLoaderContext.Provider value={value}>{children}</DataLoaderContext.Provider>;
}

export default DataLoaderContext;
